'use client';

import { getLanguageFromLocale } from '@bomdisoft/translations';
import s from '@pieleaf/app/[lang]/home/sections/final-cta/styles.module.css';
import { checkOrderText, finalCtaBody, finalCtaTitle, orderProduceText } from '@pieleaf/translations';
import Link from 'next/link';
import { useParams } from 'next/navigation';

export const FinalCtaSection = () => {
  const params = useParams();
  const lang = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(lang);

  return (
    <section className={s.section} data-testid='final-cta-section'>
      <div className={s.panel}>
        <div className={s.copy}>
          <h2 className={s.heading}>{finalCtaTitle[language]}</h2>
          <p className={s.body}>{finalCtaBody[language]}</p>
        </div>
        <div className={s.actions}>
          <Link className={s.primary} data-prodantix='Place an order' data-prodantix-action='place_order' data-testid='final-cta-order' href={`/${lang}/orders`}>
            {orderProduceText[language]}
          </Link>
          <Link className={s.secondary} data-prodantix='Check an order status' data-prodantix-action='check_order' data-testid='final-cta-status' href={`/${lang}/orders`}>
            {checkOrderText[language]}
          </Link>
        </div>
      </div>
    </section>
  );
};
